import { useQueryClient, useMutation } from '@tanstack/react-query';
import { bulkMoveAccounts } from "../orgPanelApiCalls";
import { key as structuralHierarchyKey } from "../queries/useStructuralHierachyQuery";
import { key as moveSelectedKey } from "../queries/useMoveSelectedQuery"


const useMoveSelectedMutation = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (request) => {

            const data = await bulkMoveAccounts(request.destinationAccount, request.accountsToMove);
            return data;
        },
        onSuccess: (data) => {
            queryClient.setQueryData([structuralHierarchyKey], (previousData) => {
                return previousData.map(a => {
                    let newData = data.find(x => x.accountId === a.accountId);

                    if(newData){
                        return newData;
                    }

                    return a;            
                })
            })
            
            queryClient.setQueryData([moveSelectedKey], () => {
                return data;
            });
        },
    })
}

export { useMoveSelectedMutation };